export const messageTypes = {
  themeUpdate: 'REVENI_THEME_UPDATE',
  iframeReady: 'REVENI_IFRAME_READY',
}
